export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14087.980c513f.jpg";